import React, { useEffect, useContext, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { CartContext } from "./CartContext";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Success = () => {
  const navigate = useNavigate();
  const { setCartItems } = useContext(CartContext);
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    // vide panier local
    localStorage.removeItem("cart");
    localStorage.removeItem("checkoutInfo");
    setCartItems([]);
  }, [setCartItems]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const oid = urlParams.get("orderId");
    const email = urlParams.get("email");
    setOrderId(oid);

    if (oid && email) {
      fetch("/api/send-confirmation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderId: oid, email }),
      }).catch(() => {});
    }

    // Optionnel : only if you add the route in backend
    // fetch("/api/notify-admin", ...)
  }, []);

  return (
    <div className="page">
      <Helmet>
        <title>Paiement confirmé – Deenzine</title>
        <meta name="description" content="Merci ! Ton paiement a été confirmé. Un email de confirmation a été envoyé." />
        <link rel="canonical" href={window.location.origin + "/success"} />
      </Helmet>

      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad" style={{ maxWidth: 720, margin: "0 auto", textAlign: "center" }}>
            <div className="badge">🎉 Paiement validé</div>
            <h1 className="h2" style={{ marginTop: 10, color: "var(--brand)" }}>Merci pour ta commande !</h1>
            <p className="p">
              Un email de confirmation a été envoyé. Tu recevras une notification à l’expédition.
            </p>

            {orderId && (
              <div className="badge" style={{ marginTop: 12 }}>
                Numéro de commande : <strong>#{orderId}</strong>
              </div>
            )}

            <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 18, flexWrap: "wrap" }}>
              <button className="btn" onClick={() => navigate("/")}>
                Retour accueil
              </button>
              <button className="btn btnSecondary" onClick={() => navigate("/account")}>
                Voir mes commandes
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Success;
